<template>
  <div>
    <van-calendar :poppable="false"
                  :show-title="false"
                  :show-subtitle="false"
                  color="#70B0D2"
                  :min-date="minDate"
                  :max-date="new Date()"
                  :show-confirm="false"
                  @select="select"
                  style="height: calc(100vh - 320px)">
      <template #bottom-info="{date, type}">
        <div v-if="type !== 'disabled' && date && punchTimeMap[date.format('yyyy-MM-dd')]"
             style="display: inline-block; width: 6px; height: 6px; border-radius: 3px;"
             :style="calendarItemStyle(date, type)">
        </div>
      </template>
    </van-calendar>
    <div class="van-hairline--top" style="margin: 10px 0"></div>
    <div style="display: flex; flex-direction: column; margin: 40px; height: 120px">
      <div style="height: 16px; line-height: 16px; font-size: 16px">
        <div style="display: inline-block; width: 16px; height: 16px; border-radius: 8px;"
             :style="{'background-color': curPunchInTime ? '#1989fa' : 'gray'}">
        </div>
        <label style="margin-left: 20px;">上班</label>
        <label style="margin-left: 10px">{{curPunchInTime ? curPunchInTime : '未打卡'}}</label>
      </div>
      <div style="flex-grow: 1; width: 2px; border-radius: 1px; background-color: gray; margin: 8px"></div>
      <div style="height: 16px; line-height: 16px; font-size: 16px">
        <div style="display: inline-block; width: 16px; height: 16px; border-radius: 8px; background-color: #1989fa"
             :style="{'background-color': curPunchOutTime ? '#1989fa' : 'gray'}">
        </div>
        <label style="margin-left: 20px;">下班</label>
        <label style="margin-left: 10px">{{curPunchOutTime ? curPunchOutTime : '未打卡'}}</label>
      </div>
    </div>
  </div>
</template>

<script>
  import { Calendar, NavBar } from 'vant'

  export default {
    name: 'WxPunchInRecord',
    components: {
      [Calendar.name]: Calendar,
      [NavBar.name]: NavBar
    },
    props: {
      punchTimeList: Array
    },
    data () {
      return {
        curDate: new Date().format('yyyy-MM-dd')
      }
    },
    methods: {
      calendarItemStyle (date, type) {
        if (!date) return {}
        if (date.format('yyyyMMdd') === new Date().format('yyyyMMdd')) {
          return {
            'background-color': '#4efa2c'
          }
        }
        if (type === 'selected') {
          return {
            'background-color': 'orange'
          }
        }
        return {
          'background-color': '#1989fa'
        }
      },
      select (date) {
        this.curDate = date.format('yyyy-MM-dd')
      }
    },
    computed: {
      minDate () {
        const date = new Date()
        date.setTime(date.getTime() - 60 * 24 * 60 * 60 * 1000)
        return date
      },
      punchTimeMap () {
        const timeMap = {}
        for (const item of this.$store.state.user.punchTimeList) {
          timeMap[item.punchInTime.split(' ')[0]] = item
        }
        return timeMap
      },
      curPunchInTime () {
        const punch = this.punchTimeMap[this.curDate]
        return punch ? punch.punchInTime.split(' ')[1] : null
      },
      curPunchOutTime () {
        const punch = this.punchTimeMap[this.curDate]
        if (!punch || !punch.punchOutTime) return null
        return punch.punchOutTime.split(' ')[1]
      }
    }
  }
</script>

<style scoped>

</style>
